
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSmartMatchConfigByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adminId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smart_match_configs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adminId"}}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manager_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"admin_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_match_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availability_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exclude_do_not_use_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required_skills_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location_radius_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location_radius_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location_radius_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preferred_language_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preferred_language_proficiency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"soft_skills_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_type_match_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previous_engagements_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previous_engagements_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transportation_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rating_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rating_min_stars"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favourited_resource_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hours_available_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hours_available_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_match_config_transportations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transportation_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"smart_match_criteria_orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterion_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort_order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1028}};
    doc.loc.source = {"body":"query GetSmartMatchConfigByAdmin($adminId: uuid!) {\n  smart_match_configs(where: { admin_id: { _eq: $adminId } }) {\n    id\n    manager_id\n    admin_id\n    smart_match_enabled\n    availability_enabled\n    exclude_do_not_use_enabled\n    required_skills_enabled\n    location_radius_enabled\n    location_radius_value\n    location_radius_unit\n    preferred_language_enabled\n    preferred_language_proficiency\n    soft_skills_enabled\n    title_type_match_enabled\n    previous_engagements_enabled\n    previous_engagements_min\n    transportation_enabled\n    rating_enabled\n    rating_min_stars\n    favourited_resource_enabled\n    hours_available_enabled\n    hours_available_min\n    created_at\n    updated_at\n    \n    # Get transportation preferences\n    smart_match_config_transportations {\n      id\n      transportation_type\n      created_at\n    }\n    \n    # Get criteria order\n    smart_match_criteria_orders(order_by: { sort_order: asc }) {\n      id\n      criterion_type\n      sort_order\n      created_at\n      updated_at\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetSmartMatchConfigByAdmin"] = oneQuery(doc, "GetSmartMatchConfigByAdmin");
        
